module.exports = __webpack_public_path__ + "static/media/tabs-icon-list.070bdcf8.svg";